import { URI_REPORT } from '@/config/config'

export default async ({ rootState }) => {
  const token = rootState['DATA-ACCESS'].tokenAuth;
  const userToken = rootState['DATA-ACCESS'].userToken;
  
  const opts = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      'user-token': userToken,
    },
  }

  const userLoginInfoResult = await fetch(`${URI_REPORT}analytics/agent/users`, opts)
  const jsonResult = await userLoginInfoResult.json()

  if (jsonResult.errors) {
    return Promise.reject(jsonResult.errors)
  }
  
  return jsonResult.users
}